/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1UserUseridDefaultPasswordMutationRequest,
  PostApiV1UserUseridDefaultPasswordMutationResponse,
  PostApiV1UserUseridDefaultPasswordPathParams,
  PostApiV1UserUseridDefaultPassword400,
  PostApiV1UserUseridDefaultPassword401,
  PostApiV1UserUseridDefaultPassword500,
} from "../../types/userCredenciaisController/PostApiV1UserUseridDefaultPassword.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1UserUseridDefaultPassword } from "../../clients/userCredenciaisController/postApiV1UserUseridDefaultPassword.ts";

export const postApiV1UserUseridDefaultPasswordMutationKey = () =>
  [{ url: "/api/v1/user/:userId/default-password" }] as const;

export type PostApiV1UserUseridDefaultPasswordMutationKey = ReturnType<
  typeof postApiV1UserUseridDefaultPasswordMutationKey
>;

export function postApiV1UserUseridDefaultPasswordMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1UserUseridDefaultPasswordMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1UserUseridDefaultPasswordMutationKey();
  return mutationOptions<
    PostApiV1UserUseridDefaultPasswordMutationResponse,
    ResponseErrorConfig<
      | PostApiV1UserUseridDefaultPassword400
      | PostApiV1UserUseridDefaultPassword401
      | PostApiV1UserUseridDefaultPassword500
    >,
    {
      userId: PostApiV1UserUseridDefaultPasswordPathParams["userId"];
      data?: PostApiV1UserUseridDefaultPasswordMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ userId, data }) => {
      return postApiV1UserUseridDefaultPassword(userId, data, config);
    },
  });
}

/**
 * @description Redefine a senha permanente do usuário para o valor informado (ou para a senha padrão configurada na empresa do operador, se houver). A senha é criptografada, o campo ChangePassword é marcado como verdadeiro e a alteração é propagada para o SSO. Valida permissão de empresa do operador sobre o usuário alvo. Operadores com perfil Seller ou SellerManager não podem redefinir senhas de usuários com perfil diferente de Básico. **(Requer Authorization para autenticação)**
 * @summary Redefinir senha padrão do usuário (Requer Authorization para autenticação)
 * {@link /api/v1/user/:userId/default-password}
 */
export function usePostApiV1UserUseridDefaultPassword<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1UserUseridDefaultPasswordMutationResponse,
      ResponseErrorConfig<
        | PostApiV1UserUseridDefaultPassword400
        | PostApiV1UserUseridDefaultPassword401
        | PostApiV1UserUseridDefaultPassword500
      >,
      {
        userId: PostApiV1UserUseridDefaultPasswordPathParams["userId"];
        data?: PostApiV1UserUseridDefaultPasswordMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1UserUseridDefaultPasswordMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1UserUseridDefaultPasswordMutationKey();

  const baseOptions = postApiV1UserUseridDefaultPasswordMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1UserUseridDefaultPasswordMutationResponse,
    ResponseErrorConfig<
      | PostApiV1UserUseridDefaultPassword400
      | PostApiV1UserUseridDefaultPassword401
      | PostApiV1UserUseridDefaultPassword500
    >,
    {
      userId: PostApiV1UserUseridDefaultPasswordPathParams["userId"];
      data?: PostApiV1UserUseridDefaultPasswordMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PostApiV1UserUseridDefaultPasswordMutationResponse,
    ResponseErrorConfig<
      | PostApiV1UserUseridDefaultPassword400
      | PostApiV1UserUseridDefaultPassword401
      | PostApiV1UserUseridDefaultPassword500
    >,
    {
      userId: PostApiV1UserUseridDefaultPasswordPathParams["userId"];
      data?: PostApiV1UserUseridDefaultPasswordMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1UserUseridDefaultPasswordMutationResponse,
    ResponseErrorConfig<
      | PostApiV1UserUseridDefaultPassword400
      | PostApiV1UserUseridDefaultPassword401
      | PostApiV1UserUseridDefaultPassword500
    >,
    {
      userId: PostApiV1UserUseridDefaultPasswordPathParams["userId"];
      data?: PostApiV1UserUseridDefaultPasswordMutationRequest;
    },
    TContext
  >;
}
